export const business = [
    {
        title: '京禧建设',
        subtitle: '地产、城市更新、建筑产业',
        cover: 'business/cover-1.jpg',
        content: 'business/detail/build.ext.md'
    },
    {
        title: '京禧资管',
        subtitle: '村集体经济产业、物业管理',
        cover: 'business/cover-2.jpg',
        content: 'business/detail/asset.ext.md'
    },
    {
        title: '京禧商业',
        subtitle: '酒店产业',
        cover: 'business/cover-3.jpg',
        content: 'business/detail/commerce.ext.md'
    },
    {
        title: '京禧教育',
        subtitle: '教育产业',
        cover: 'business/cover-4.jpg',
        content: 'business/detail/education.ext.md'
    }
];